<div class="no-genealogy-data" *ngIf="genealogies?.length === 0"> Did not find any genealogy data </div>
<div class="genealogy-chart" [ngClass]="{ 'no-data': genealogies?.length === 0 }" #chartContainer></div>
